// extracted by mini-css-extract-plugin
module.exports = {"noDataText":"HistoryOrders_noDataText__2Bg6G"};